import React, { useCallback, useState } from 'react';
import { Button } from 'antd';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

import { TEST_IDS } from '../test-ids';

import './styles.scss';

interface Props {
	showMessage: boolean;
	message: string;
}

export const ReadOnlyMessage: React.FC<Props> = ({ showMessage, message }) => {
	const [showReadOnlyMessage, setShowReadOnlyMessage] = useState(showMessage);
	const closeMessage = useCallback(() => setShowReadOnlyMessage(false), []);

	return (
		<>
			{showReadOnlyMessage && (
				<div className="read-only-message" data-test-id={TEST_IDS.ReadOnlyMessage}>
					<BringgIcon iconName={BringgFontIcons.InfoFilled} className="info-icon" />
					<div className="message">{message}</div>
					<Button
						shape="circle"
						className="hide-message"
						onClick={closeMessage}
						icon={<BringgIcon iconName={BringgFontIcons.Close} />}
						data-test-id={TEST_IDS.CloseReadOnlyMessage}
					/>
				</div>
			)}
		</>
	);
};
